import { AppSellerApplicationApi } from '../../generated/api';
import configuration from './configuration';

export default new AppSellerApplicationApi(configuration);
